/**
 * The TMDB sync as the admin dashboard sees it: how the last runs went, how
 * fresh the catalog is, and what a manual run may be asked to do.
 */
/** Upper bound for a manual run's details limit. */
export const TMDB_MAX_DETAILS_LIMIT = 50_000;
